module.exports = __webpack_public_path__ + "img/curious.7b7a0a54.svg";